export default __webpack_public_path__ + "static/media/rounded-flag.6f808bf2.webp";